// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3MDoD","title":"FrontImage_title__3zruF"};